module.exports = __webpack_public_path__ + "img/customer_small.da5d0b28.jpg";